import { connect } from 'react-redux';
import { toggleBurgerMenuRequested } from '../../redux/actions';
import { getIsBurgerMenuOpen } from '../../redux/selectors';
const mapStateToProps = (state)=>({
        isBurgerMenuOpen: getIsBurgerMenuOpen(state)
    });
const mapDispatchToProps = {
    toggleBurgerMenu: toggleBurgerMenuRequested
};
export default connect(mapStateToProps, mapDispatchToProps);

//# sourceMappingURL=Burger.container.js.map